import { getFileNativeUriScheme } from '@office-start/file-utility';
export function getNativeUrl(content) {
    if (!content.fileType ||
        content.isEmailAttachment ||
        !content.canonicalUrl) {
        return undefined;
    }
    // Make sure there's a native Uri scheme for this fileType
    var nativeUriScheme = getFileNativeUriScheme(content.fileType);
    if (!nativeUriScheme) {
        return undefined;
    }
    // Get canonical url
    var queryIndex = content.canonicalUrl.lastIndexOf('?');
    var canonicalUrl = content.canonicalUrl;
    if (queryIndex > 0) {
        // Strip any query params off the canonical url, as it is not needed for launching desktop apps
        canonicalUrl = content.canonicalUrl.substring(0, queryIndex);
    }
    return "".concat(nativeUriScheme).concat(canonicalUrl);
}
//# sourceMappingURL=getNativeUrl.js.map